import { render } from "./Index.vue?vue&type=template&id=511cf897"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=511cf897&lang=css"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\32\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__